// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2Zg5S","content":"styles_content__3t2lb","selectAll":"styles_selectAll__2iTly"};